import { RX } from '../constants';

module.exports = (flex = window.flex) => {

    const { trigger, Timer } = flex;

    class TimingTracker {
        constructor(action) {
            this.metadata = [{ prefix: 'Timing', values: { action } }];
            this.timers = [];
        }

        addMetadata(prefix, values) {
            let errors = false;
            if (!prefix || typeof (prefix) !== 'string') {
                console.warn('`TimingTracker.addMetadata(prefix, values)` requires a string value for `prefix` be provided');
                errors = true;
            }
            if (!values || typeof (values) !== 'object') {
                console.warn('`TimingTracker.addMetadata(prefix, values)` requires an object value for `values` be provided');
                errors = true;
            }
            if (errors) {
                return;
            }
            let metadata = this.metadata.find(m => m.prefix === prefix);
            if (metadata) {
                Object.assign(metadata.values, values);
            }
            else {
                this.metadata.push({
                    prefix,
                    values: Object.assign({}, values)
                })
            }
        }

        addTimer(label, timer) {
            if (!(timer instanceof Timer)) {
                console.warn('Cannot add non `Timer` timer');
                return;
            }
            timer.key = label;
            this.timers.push(timer);
        }

        track() {
            trigger(RX.TRACK.TIMING, { timers: this.timers, metadataCollection: this.metadata });
        }
    }

    return TimingTracker;
};